module.exports = __webpack_public_path__ + "static/media/arrow_up.7c14e501.svg";